import { useQuery } from '@tanstack/react-query';

import { captureException } from '../../logger/Logger';
import { useMastraClient } from '../providers/MastraClient';

export const useGetTrace = ({
    traceId,
    enabled = true,
}: {
    traceId: string | null | undefined;
    enabled?: boolean;
}) => {
    const mastraClient = useMastraClient();

    return useQuery({
        queryKey: ['observability-trace', traceId],
        queryFn: async () => {
            if (traceId == null) {
                throw new Error('Trace ID is required');
            }

            try {
                return await mastraClient.getTrace(traceId);
            } catch (err) {
                captureException(err);
                throw err;
            }
        },
        enabled: enabled && traceId != null,
        refetchInterval: 3000,
        refetchOnWindowFocus: false,
    });
};
